import { useEffect } from 'react';
import { AccessibilityAuditor } from '../components/AccessibilityAuditor';
import { useToolInit } from '../hooks/useToolInit';
import { useToolState } from '../contexts/ToolStateContext';

export function AccessibilityTool() {
  const { params } = useToolInit();
  const { setToolState, getToolState } = useToolState();

  // Deep-link: ?fg= and ?bg= seed the auditor's foreground/background
  useEffect(() => {
    if (params.fg || params.bg) {
      const persisted = getToolState('accessibility');
      setToolState('accessibility', {
        ...persisted!,
        foreground: params.fg ?? persisted?.foreground ?? '#000000',
        background: params.bg ?? persisted?.background ?? '#ffffff',
        foregroundAlpha: persisted?.foregroundAlpha ?? 1,
        backgroundAlpha: persisted?.backgroundAlpha ?? 1,
        textSize: persisted?.textSize ?? 16,
        isBold: persisted?.isBold ?? false,
        targetCompliance: persisted?.targetCompliance ?? 'aa',
        savedPairs: persisted?.savedPairs ?? [],
      });
    }
  }, [params.fg, params.bg]); // eslint-disable-line react-hooks/exhaustive-deps

  return <AccessibilityAuditor />;
}
